// LICENSE_CODE ZON ISC
'use strict';

/*jslint browser:true*/
define(['/util/url.js', 'cookie'], function (zurl, cookie) {
  var E = {};
  var is_dashboard_url = function is_dashboard_url(url) {
    url = url || location.pathname;
    return /^(?:https?:\/\/[^/]+)?\/(?:cp|sdk_api|api|download)(?:\/|$)/.test(url);
  };
  var get_cookie_name = function get_cookie_name(url) {
    return location.hostname == 'rewardgum.com' || location.hostname == 'bright-sdk.com' && !is_dashboard_url(url) ? 'xsrf-token' : 'XSRF-TOKEN';
  };
  E.get = function (url) {
    return cookie.get(get_cookie_name(url));
  };
  E.add = function (form) {
    var el = document.createElement('input');
    el.name = 'csrf_token';
    el.type = 'hidden';
    el.value = E.get();
    form.appendChild(el);
  };
  E.on_ajax_send = function (xhr, opt) {
    if (opt.type != 'POST') return;
    var current = zurl.parse(location.href, true);
    var target = zurl.parse(opt.url, true);
    if (target.host) {
      if (target.protocol != current.protocol || target.host != current.host) return;
    }
    xhr.setRequestHeader('X-XSRF-Token', E.get(opt.url));
  };
  return E;
});